import { z } from '@harvestiq/zod';

export const forgotPasswordRequestSchema = z.object({
  email: z.string().email().toLowerCase().trim(),
});

export type ForgotPasswordRequest = z.infer<typeof forgotPasswordRequestSchema>;
